import { DefaultThunk } from "stores";
import {
  addRoomDeckItems,
  returnRoomDeckItems,
} from "stores/modules/entities.room.decks/operations";
import { UpdateItem } from "stores/modules/entities.room.items";

export type DrawCardRecord = {
  kind: "draw-card";
  deckId: string;
  before: UpdateItem[];
  after: UpdateItem[] | null;
};

export const undoDrawCard =
  (history: DrawCardRecord): DefaultThunk =>
  (dispatch, _) => {
    const before = history.before;
    const after = history.after;
    if (after) {
      // 変更後データが存在する場合はドローが行われたため、カードを山札に戻す
      const ids: string[] = after
        .map((item) => item._id)
        .filter((id): id is string => id !== undefined);
      dispatch(addRoomDeckItems(history.deckId, before, ids));
      return;
    }

    // 変更後データが存在しない場合は山札にカードを戻しているため、カードを変更前に戻す
    const ids: string[] = before
      .map((item) => item._id)
      .filter((id): id is string => id !== undefined);
    dispatch(returnRoomDeckItems(history.deckId, before, ids));
    return;
  };

export const redoDrawCard =
  (history: DrawCardRecord): DefaultThunk =>
  (dispatch, _) => {
    const after = history.after;
    const before = history.before;
    const ids = before
      .map((item) => item._id)
      .filter((id): id is string => id !== undefined);
    if (after) {
      // 変更後データが存在する場合はドローのRedoとして、カードと山札の状態を更新する
      dispatch(returnRoomDeckItems(history.deckId, after, ids));
      return;
    }

    // 変更後データが存在する場合は山札に戻すのRedoとしてる、山札からカードを作成する
    dispatch(addRoomDeckItems(history.deckId, before, ids));
    return;
  };
